import { checkNutriScore } from "../helpers";

const imgBaseUrl = "app/themes/oqali-website-2021/dist/images/"; //@TODO env ?

const NutriScore: React.FC<{ value: string }> = ({ value }) => {
    const score = checkNutriScore(value);
    if (!score) {
        return null;
    }
    return <img src={`${process.env.REACT_APP_WP_URL}${imgBaseUrl}nutriscore_${score}.svg`} alt={score} />;
};

export default NutriScore;
